import { render } from "./404.vue?vue&type=template&id=01cbd5aa&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=01cbd5aa&lang=less"
import "./404.vue?vue&type=style&index=1&id=01cbd5aa&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/local/v-7pa-xling/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01cbd5aa"]])

export default __exports__